import { app } from '../../app.module'
/*
 * SnsSelectTabService SNSタブが選択された際の処理をまとめたサービス
 */
function SnsSelectTabService($rootScope) {
  /**
   * ローカルストレージに保存されていたSNSの利用許可があるかどうかチェックし、
   * 無い場合は、許可されたSNSを選択されたSNSとする
   * @param {string} selectedSns 選択されたSNS
   */
  function checkLocalTab(selectedSns) {
    // 権限のあるSNSがローカルストレージに保存されていた場合は、
    // そのまま表示を許可する
    if (selectedSns === 'facebook' && $rootScope.flgFacebook === true) {
      return selectedSns
    }
    if (selectedSns === 'twitter' && $rootScope.flgTwitter === true) {
      return selectedSns
    }
    if (selectedSns === 'instagram' && $rootScope.flgInstagram === true) {
      return selectedSns
    }
    if (selectedSns === 'youtube' && $rootScope.flgYoutube === true) {
      return selectedSns
    }
    if (selectedSns === 'line' && $rootScope.flgLine === true) {
      return selectedSns
    }
    if (selectedSns === 'tiktok' && $rootScope.flgTiktok === true) {
      return selectedSns
    }

    // 許可のないSNSがローカルストレージに保存されていた場合は、
    // 許可のあるSNSをローカルストレージのSNSに代わって表示する
    if ($rootScope.flgFacebook === true) {
      return 'facebook'
    }
    if ($rootScope.flgTwitter === true) {
      return 'twitter'
    }
    if ($rootScope.flgInstagram === true) {
      return 'instagram'
    }
    if ($rootScope.flgYoutube === true) {
      return 'youtube'
    }
    if ($rootScope.flgLine === true) {
      return 'line'
    }
    if ($rootScope.flgTiktok === true) {
      return 'tiktok'
    }
  }

  /**
   * SNSの利用許可ごとに、表示するタブのインデックスを取得する
   * @return {object} 各SNSごとのタブのインデックス
   */
  function getTabIndex() {
    let fbIndex
    let twIndex
    let inIndex
    let ytIndex
    let lineIndex
    let ttIndex

    // 利用許可がある場合はタブのインデックスを付与する。
    // インデックスは0からスタートし、
    // インデックスを付与した場合はインクリメントする
    let tabIndex = 0

    if ($rootScope.flgFacebook === true) {
      fbIndex = tabIndex
      tabIndex = tabIndex + 1
    }
    if ($rootScope.flgTwitter === true) {
      twIndex = tabIndex
      tabIndex = tabIndex + 1
    }
    if ($rootScope.flgInstagram === true) {
      inIndex = tabIndex
      tabIndex = tabIndex + 1
    }
    if ($rootScope.flgYoutube === true) {
      ytIndex = tabIndex
      tabIndex = tabIndex + 1
    }
    if ($rootScope.flgLine === true) {
      lineIndex = tabIndex
      tabIndex += 1
    }
    if ($rootScope.flgTiktok === true) {
      ttIndex = tabIndex
      tabIndex += 1
    }

    return {
      facebook: fbIndex,
      twitter: twIndex,
      instagram: inIndex,
      youtube: ytIndex,
      line: lineIndex,
      tiktok: ttIndex,
    }
  }

  return {
    checkLocalTab: checkLocalTab,
    getTabIndex: getTabIndex,
  }
}

app.factory('SnsSelectTabService', SnsSelectTabService)
